import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private messageService: MessageService) {}

  private showToast(severity: string, message: string, detail?: string) {
    this.messageService.clear();

    this.messageService.add({
      severity,
      summary: message,
      detail: detail || '',
      life: 3000,
    });
  }

  success(message: string, detail?: string) {
    this.showToast('success', 'Success', message);
  }

  info(message: string, detail?: string) {
    this.showToast('info', 'Info', message);
  }

  warn(message: string, detail?: string) {
    this.showToast('warn', 'Warning', message);
  }

  toastError(message: string, detail?: string) {
    this.showToast('error', 'Error', message);
  }

  error(title: string, text?: string) {
    if (Swal.isVisible()) return;

    Swal.fire({
      icon: 'error',
      title,
      text: text || '',
      confirmButtonColor: '#d33',
      customClass: {
        popup: this.getSwalThemeClass(),
      },
    });
  }

  private getSwalThemeClass() {
    return document.documentElement.classList.contains('dark')
      ? 'swal-dark'
      : 'swal-light';
  }
}
